import { ChatView } from './chatView/ChatView';

export default ChatView;
